module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"a":"Compétences fonctionnelles","b":"Vide."},"en":{"a":"Functional skills","b":"Empty."}}')
  delete Component.options._Ctor
}
